module.exports = __webpack_public_path__ + "img/recent-release.aa88013b.jpg";